import moment from "moment";
import React from "react";
import { Col, Row, Modal } from "react-bootstrap";

const ExpPaymentSuccessModel = ({ open, success, request, formik, experience, onPaymentDone, requestData, ...props }) => {
    console.log(request);
    return (
        <React.Fragment>
            <Modal show={success} size="md" centered>
                <Modal.Body>
                    <div style={{ backgroundColor: "#FFFBEE", padding: "15px" }}>
                        <div className="row">
                            <div className="col-6">
                                Experience ID: <span style={{ color: "#F85032" }}>{experience.expId}</span>
                            </div>
                        </div>

                        <h1>Payment {success ? "Success" : "Failed"}</h1>
                        <div className="d-flex align-items-center">
                            <img
                                src={require(`../../assets/images/superadmin/ordericon/${success ? `success` : `failed`
                                    }.svg`)}
                                width="45px"
                                heigth="15px"
                            />{" "}
                            <div className="ml-2 f14-400">
                                {success
                                    ? "Your payment has been successfully made"
                                    : "Your payment has been declined"
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
                        Experience Request Number :{" "}
                        <span style={{ color: "#F85032" }}>{requestData.requestId}</span>
                        <br />
                        <Row>
                            <Col xs={12}>
                                <div className="f14_400">
                                    <b>{request?.adultCount + request?.package?.adults} Adults {(request?.kidsCount || request?.package?.kids) ? `| ${request?.kidsCount + request?.package?.kids} Child` : null}</b>
                                </div>
                                <span className="f10_400">
                                    (Seat Selection Not Available at this time, will be assigned at the Event)
                                </span>
                            </Col>
                        </Row>
                    </div>
                    {/* <hr /> */}
                    <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
                        Transaction ID :{" "}
                        <span style={{ color: "#F85032" }}>{Math.floor(10000000 + Math.random() * 90000000)}</span>
                        <br />
                        <Row>
                            <Col xs={6}>
                                <b>{moment().format('LL')}</b>
                                <br />
                                <span style={{ color: "#757575" }}>Date</span>
                            </Col>
                            <Col xs={6}>
                                <b>{moment().format('LT')} </b>
                                <br />
                                <span style={{ color: "#757575" }}>Time</span>
                            </Col>
                        </Row>
                    </div>
                    <br />
                    <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <b>Sub Total</b>
                                    </td>
                                    <td>
                                        <b>₹ {request.paymentData.amount}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Donation</td>
                                    <td>₹ {request.paymentData.donationAmount}</td>
                                </tr>

                                <tr
                                    style={{
                                        backgroundColor: "#F8F8F8",
                                    }}
                                >
                                    <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                                        <b>Paid</b>
                                    </td>
                                    <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                                        <b>₹ {request.paymentData.totalAmount}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr />
                    <button
                        type="button"
                        class="onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
                        title="Done"
                        onClick={() => {
                            onPaymentDone()
                        }}
                    >
                        Done
                    </button>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default ExpPaymentSuccessModel;